var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.80571L11.1943 4L8 7.19429L4.80571 4L4 4.80571L7.19429 8L4 11.1943L4.80571 12L8 8.80571L11.1943 12L12 11.1943L8.80571 8L12 4.80571Z",
    fill: "#0A1229"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconFilled);
export default __webpack_public_path__ + "static/media/crossIconFilled.aa4f7e5d8578f3de39aa4c08b029c6fe.svg";
export { ForwardRef as ReactComponent };